import { HydratedInterface } from "@zapier/client";
import { InterfaceModal, useInterfaceRow } from "@zapier/interfaces";
import { FolderModal } from "@zapier/shared";
import AssetRow from "./AssetRow";

interface Props {
  allowSelection?: boolean;
  interfaceObj: HydratedInterface;
  setCurrentModal: (modal: InterfaceModal | FolderModal | undefined) => void;
  setCurrentInterface: (zInterface: HydratedInterface | undefined) => void;
  folderId?: string;
  showLastRun?: boolean;
  showLocationColumn?: boolean;
  onCopyToAnotherAccount?: (asset: HydratedInterface) => void;
}

export function AssetRowInterface({
  allowSelection,
  interfaceObj,
  setCurrentModal,
  setCurrentInterface,
  folderId,
  showLastRun,
  showLocationColumn,
  onCopyToAnotherAccount,
}: Props) {
  const { menuItems, permissions } = useInterfaceRow({
    interfaceObj,
    setCurrentModal,
    setCurrentInterface,
    onCopyToAnotherAccount,
  });

  const updatedAt = interfaceObj.updatedAt
    ? new Date(interfaceObj.updatedAt)
    : undefined;

  return (
    <AssetRow
      allowSelection={allowSelection}
      asset={interfaceObj}
      folderZapTableRow={true}
      isUntitled={interfaceObj?.name?.length === 0}
      menuItems={menuItems}
      onOpenMenu={permissions.enablePermissionsCheck}
      title={interfaceObj.name}
      updatedAt={updatedAt}
      folderId={folderId}
      showLastRun={showLastRun}
      showLocationColumn={showLocationColumn}
    />
  );
}
